import axios from 'axios';
import store from '@/store';
import vueRouter from '@/router/index';
import HttpStatus from 'http-status-codes';

// リクエストパラメータを初期化
axios.defaults.params = {};

// リクエスト前に処理を追加する
axios.interceptors.request.use(
    // 正常の場合
    function (config) {
        if (store.state.isAccessLog) {
            // アクセスログ出力フラグがtrueの場合
            // パラメータに「1」で設定後、ストアで保持している値をfalseにする（同じ画面で一度しか出力しない）
            config.params['isAccessLog'] = 1;
            store.commit('setIsAccessLog', false);
        } else {
            // アクセスログ出力フラグがfalseの場合
            // パラメータに「0」で設定
            config.params['isAccessLog'] = 0;
        }
        // 画面名の設定
        config.params['displayName'] = store.state.displayName;
        config.params['displayId'] = store.state.logDisplayId;
        return config;
    },
    // エラーの場合
    function (error) {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    // 正常の場合
    function (response) {
        // root.state.authenticationStatusにtrueを設定する
        store.commit('setAuthenticationStatus', true, { root: true });
        return response
    },
    // エラーの場合
    function (error) {
        // 401エラーの場合
        if (error.response.status === HttpStatus.UNAUTHORIZED) {
            // root.state.authenticationStatusにtrueを設定する
            store.commit('setAuthenticationStatus', false, { root: true });
            // root.state.authenticationUserをクリアする
            store.commit('setAuthenticationUser', null, { root: true });
            // エラー画面を表示する
            store.commit('setErrorMessage', error.response.data.message);
            vueRouter.push('/error');
        } else {
            return Promise.reject(error)
        }
    }
)
export default axios;

